module.exports = __webpack_public_path__ + "img/store_apple.612061be.png";